module.exports = __webpack_public_path__ + "img/refreshing.b5424b78.svg";